// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".applicant-waiters-list-tab[data-v-469d1cd8]{width:100%}.applicant-waiters-list-tab .waiter-label[data-v-469d1cd8]{margin:2px 0;font-size:12px;padding:4px;border-radius:.25rem}.applicant-waiters-list-tab .advanced-setting-reset-btn[data-v-469d1cd8]{height:32px!important;font-size:16px!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
